export default {
  path: '/listings/changes/:listingId',
  name: 'listing-changes',
  meta: {
    requiresAuth: true,
  },
  component: () => import('@/modules/listing-changes/pages/Entry.vue'),
};
  